// extracted by mini-css-extract-plugin
module.exports = {"like":"comment_like__N4Odw","like_icon":"comment_like_icon___NFT7","active":"comment_active__PmbDm"};